import { render, staticRenderFns } from "./FindPW.vue?vue&type=template&id=70fa580d&scoped=true&"
import script from "./FindPW.vue?vue&type=script&lang=ts&"
export * from "./FindPW.vue?vue&type=script&lang=ts&"
import style0 from "./FindPW.vue?vue&type=style&index=0&id=70fa580d&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70fa580d",
  null
  
)

export default component.exports